<template>
    <div class="slider-container">
        <input type="range"
            :min="min"
            :max="max"
            :step="step"
            v-model="sliderValue"
            @input="updateRangeProperty($event.target.value);"
            :style="styleOfObject">
    </div>
</template>
<script>
export default {
    props:{
        value: false,
        step: {
            default: 100,
            type: Number
        },
        min: {
            default: 100
        },
        max: {
            default: 100
        },
    },
    data: function() {
        return {
            proxVal: this.max
        }
    },
    computed: {
        sliderValue: {
            get () {
                this.updateRangeStyle(this.value);
                return this.value
            },
            set (val) {
                this.proxVal = val
            }
        }
    },
    methods:{
        /**
         * [Emit faux "input" event on change]
         * @param  {[text]} key
         * @param  {[number | text]} value
         */
        updateRangeProperty(value) {
            this.$emit('input', value);
        },

        /**
         * [update input range element's style]
         */
        updateRangeStyle: function(numVal) {
            var val = (numVal - this.min) / (this.max - this.min);
            var percent = (val * 100);
            this.styleOfObject = `background-image: -webkit-gradient(linear,left top, right top, color-stop(${percent}%,#49B672),color-stop(${percent}%,#DEDEDE))`;
        },
    }
}
</script>
